import { useState, useContext } from 'react';

import Layout from '../components/Layout';
import Map from '../components/Map';
import ListadoProductosPedidos from '../components/ListadoProductosPedidos';


const Pedidos = () => {
	const [tab, setTab] = useState(0)
	return (
		<Layout
			pagina={"Mi compra"}
		>
			<div className='flex p-5'>
				<button
					className={`p-3 rounded-lg ${tab===0 ? 'bg-blue-800 text-white shadow-md':'border border-blue-400 text-blue-400'}`}
					onClick={()=>setTab(0)}
				>
					Ver Pedidos en Mapa
				</button>
				<button
					className={`ml-5 p-3 rounded-lg ${tab===1 ? 'bg-blue-800 text-white shadow-md':'border border-blue-400 text-blue-400'}`}
					onClick={()=>setTab(1)}
				>
					Ver listado de productos para reparto
				</button>
			</div>
			<div className='w-full pt-20 pb-20'>
				{ tab === 0 ? (
					<Map />
				):(
					<div>
						<ListadoProductosPedidos />
					</div>
				)}
			</div>
		</Layout>
	)
}

export default Pedidos